import {
  Text,
  Button,
  Center,
  Stack,
  Box,
  Image,
} from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <>
      <Stack p={6} pt={`calc(1rem + env(safe-area-inset-top))`}>
        <Box textAlign="center" py={3}>
          <Image src="/logo512.png" alt="iFun Baby Logo" boxSize="150px" mx="auto" mb={4} />
          <Text fontSize="2xl" fontWeight="bold">iFun Baby Reward</Text>
          <Text fontSize="lg" color="gray.500" mt={2}>Enjoy collecting points and rewards!</Text>
        </Box>
        <Center>
          <Link to="/login">
            <Button colorScheme="teal" mr={3}>Get Started</Button>
          </Link>
        </Center>
      </Stack>
    </>
  );  
};

export default Hero;